import { render, staticRenderFns } from "./fabric.vue?vue&type=template&id=6fd40546&scoped=true&"
import script from "./fabric.vue?vue&type=script&lang=js&"
export * from "./fabric.vue?vue&type=script&lang=js&"
import style0 from "./fabric.vue?vue&type=style&index=0&id=6fd40546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd40546",
  null
  
)

export default component.exports